<template>
  <div class="print-personalization">
    <div class="logo-pdf">
      <MosaicLogo />
    </div>

    <br />
    <br />
    <AppHeading theme="black" element="h2" size="xs" spacing="xs" class="print-personalization__align-left">
      Contact
    </AppHeading>
    <table class="print-personalization__info">
      <tr class="print-personalization-info-item">
        <td class="print-personalization__align-left">Date: </td>
        <td class="print-personalization__align-right">{{ date }}</td>
      </tr>
      <tr class="print-personalization-info-item">
        <td class="print-personalization__align-left">Prepared For: </td>
        <td class="print-personalization__align-right">{{ preparedFor }}</td>
      </tr>
      <tr class="print-personalization-info-item">
        <td class="print-personalization__align-left">Prepared By: </td>
        <td class="print-personalization__align-right">{{ preparedBy }}</td>
      </tr>
      <tr class="print-personalization-info-item">
        <td class="print-personalization__align-left">Company: </td>
        <td class="print-personalization__align-right">{{ company }}</td>
      </tr>
      <tr class="print-personalization-info-item">
        <td class="print-personalization__align-left">Phone Number: </td>
        <td class="print-personalization__align-right">{{ phoneNumber }}</td>
      </tr>
    </table>
    <br />
    <br />
    <AppHeading theme="black" element="h2" size="xs" spacing="xs" class="print-personalization__align-left">
      Your Crop
    </AppHeading>
    <table class="print-personalization__info">
      <tr class="print-personalization-info-item">
        <td class="print-personalization__align-left">Crop Type: </td>
        <td class="print-personalization__align-right">{{ cropSelected }}</td>
      </tr>
      <tr class="print-personalization-info-item">
        <td class="print-personalization__align-left">Crop Price: </td>
        <td class="print-personalization__align-right">${{ retailPrice }}</td>
      </tr>
    </table>
    <br />
    <br />
    <AppHeading theme="black" element="h2" size="xs" spacing="xs" class="print-personalization__align-left">
      Blend Comparison
    </AppHeading>
    <table class="print-personalization__info">
      <tr class="print-personalization-info-item">
        <td class="print-personalization__align-left">Current Blend: </td>
        <td class="print-personalization__align-right">{{ currentBlendPDF }}</td>
      </tr>
      <tr class="print-personalization-info-item">
        <td class="print-personalization__align-left">P<sub>2</sub>O<sub>5</sub>: </td>
        <td class="print-personalization__align-right">{{ rateOfPhosphorusApplied }} {{ weightOption }}</td>
      </tr>
    </table>
    <br />
    <br />
    <AppHeading theme="black" element="h2" size="xs" spacing="xs" class="print-personalization__align-left">
      Notes
    </AppHeading>
    <br />
    <div class="print-personalization__notes">
      <hr />
      <br />
      <hr />
      <br />
      <hr />
      <br />
      <hr />
    </div>
    <br />
    <br />
    <br />
    <br />
    <div class="print-personalization__additional-info">
      <small class="print-personalization__align-left">Please note that the above information is for hypothetical, illustration purposes only, and does not constitute a guarantee of any kind as to yields, results or the pricing of any products or commodities, and that actual results will vary. Mosaic disclaims all warranties of any kind, express or implied, with respect to this application.
      <br />
      <br />
      ©2024. The Mosaic Company. All rights reserved. MicroEssentials is a registered trademark of The Mosaic Company and SZ, S15 and S10 are trademarks of The Mosaic Company.</small>
    </div>
  </div>
</template>

<script>
import AppHeading from '@/components/shared/AppHeading';
import TextContent from '@/components/shared/TextContent';
import MosaicLogo from '@/components/icons/MosaicLogo';

export default {
  components: {
    TextContent,
    AppHeading,
    MosaicLogo
  },
  props: {
    date: {
      type: String,
      required: false,
      default: '-'
    },
    preparedFor: {
      type: String,
      required: false,
      default: '-'
    },
    preparedBy: {
      type: String,
      required: false,
      default: '-'
    },
    company: {
      type: String,
      required: false,
      default: '-'
    },
    phoneNumber: {
      type: String,
      required: false,
      default: '-'
    },
    cropSelected: {
      type: String,
      required: false,
      default: '-'
    },
    retailPrice: {
      type: String,
      required: false,
      default: '-'
    },
    roiIncrease: {
      type: String,
      required: false,
      default: '-'
    },
    rateOfPhosphorusApplied: {
      type: String,
      required: false,
      default: '-'
    },
    weightOption: {
      type: String,
      required: false,
      default: '-'
    },
    currentBlendPDF: {
      type: String,
      required: false,
      default: '-'
    }
  }
}
</script>

<style lang="scss">
.print-personalization {
  position: relative;

  &__info {
    list-style-type: none;
    padding: 0;
    display: block;
    justify-content: space-between;

    tr {
      display: flex;
      justify-content: space-between;
    }
  }

  &__align-right {
    display: inline-block;
    text-align: right;
    font-size: 13px;
    vertical-align: top;
  }

  &__align-left {
    display: table-cell;
    text-align: left;
    font-size: 13px;
    padding-right: 12px;
    vertical-align: top;
  }

  &__additional-info {
    text-align: left;
    font-size: 10px;
    line-height: 8px;
    position: absolute;
    bottom: 20px;

    small {
      font-size: 10px;
      line-height: 12px;
    }
  }
  
  .logo-pdf {
    text-align: left;
    
    svg {
      width: 70px;
      height: 70px;
    }
  }
}
</style>